// Angular
import { ChangeDetectorRef, Component, Inject, OnInit, ViewRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';

@Component({
	selector: 'kt-kho-de-nghi-xuat-kho-import-warning',
	templateUrl: './kho-de-nghi-xuat-kho-import-warning.component.html',
	styleUrls: ["../kho-de-nghi-xuat-kho-page.component.scss"],
})
export class KhoDeNghiXuatKhoImportWarningtComponent implements OnInit {
	viewLoading: boolean = false;
	res = [];
	CONFIG: CommonConFig;
	constructor(public dialogRef: MatDialogRef<KhoDeNghiXuatKhoImportWarningtComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private changeDetect: ChangeDetectorRef,
	) { }

	ngOnInit() {
		this.CONFIG = new CommonConFig();
		this.res = this.data;
		this.changeDetectView();
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	onYesClick(): void {
		this.viewLoading = true;
		this.dialogRef.close(true);
	}

	changeDetectView() {
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges();
		}
	}
}
